import Vue from 'vue'
import axios from 'axios'
import config from '@/config'  // 引入配置文件
let apiBaseUrl = config.apiBaseUrl;

// 创建 axios 实例
const service = axios.create({
    baseURL: apiBaseUrl,
    timeout: 200000
})

// ========== 新增：Ticket 缓存 ==========
let ticketCache = {
    value: null,
    expireAt: 0,
    enable:false //是否启用缓存
}

// 获取 Ticket（带缓存，避免每次请求都申请）
async function getTicket(path) {
    if(ticketCache.enable){
        const now = Date.now()
        if (ticketCache.value && ticketCache.expireAt > now) {
            return ticketCache.value
        }
    }
    // 匿名获取，不需要 Token
    const res = await axios.get(`${apiBaseUrl}/api/anon/ticket?path=${encodeURIComponent(path)}`)

    if (res.data.success) {
        if(ticketCache.enable){
            ticketCache.value = res.data.result
            ticketCache.expireAt = now + 4 * 60 * 1000
        }
        return res.data.result
    }
    throw new Error(res.data.message)
}

// ========== 新增：请求拦截器 ==========
service.interceptors.request.use(
    async config => {
        // 只对匿名接口（/api/anon/ 开头，且排除 ticket 接口本身）添加 Ticket
        //if (config.url && config.url.startsWith('/api/anon/') && !config.url.includes('/ticket')) {
        //所有请求接口都添加ticket
        if (config.url) {
            try {
                const ticket = await getTicket(config.url)
                config.headers['X-Anon-Ticket'] = ticket
            } catch (err) {
                // Ticket 获取失败，可以选择继续请求（后端会拒绝）或中断
                console.error('Ticket 添加失败:', err)
            }
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

export {
    service as axios
}
